import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from '@/components/border/borderType';
import warn from '@/components/border/warn';
import ring from '@/components/env-bigData/ring.vue';
import analysisRadio from '@/components/env-bigData/analysisRadio'; // 超标因子

import trendSecond from '@/components/env-bigData/trendSecond';
import fileTable from '@/components/border/fileTable';
import { getAction } from '@/api/manage'; // 实时水文进度图

import barType from '@/components/env-bigData/barType';
import { queryWaterCurveAnalysis, queryScreenWarn, queryWastehydrologyCurveAnalysis, queryWastDateList } from '@/api/api';
import moment from 'moment';
export default {
  components: {
    fileTable: fileTable,
    border: border,
    ring: ring,
    trendSecond: trendSecond,
    barType: barType,
    warn: warn,
    analysisRadio: analysisRadio
  },
  data: function data() {
    return {
      showAnalysis: false,
      radioOptions: [],
      defaultRainValue: 1,
      showState: true,
      flowState: true,
      waterState: true,
      storageState: true,
      showReal: true,
      showState1: true,
      flowState1: true,
      waterState1: true,
      storageState1: true,
      showReal1: true,
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      data8: {},
      radioStatu: true,
      defaultValues: 0,
      waterWarnList: [],
      showRadio: false
    };
  },
  props: {
    selectId: {
      default: '0',
      type: String
    },
    selectType: {
      default: '0',
      type: String
    }
  },
  watch: {
    selectId: function selectId(val) {
      var _this = this;

      console.log('hydrologyTemp', val);
      this.getRealtime(val);
      this.showRadio = false;
      this.$nextTick(function () {
        _this.showRadio = true;
        _this.analysisType = 11;
        _this.defaultValues = 1;

        _this.$nextTick(function () {
          _this.getWarn(_this.defaultValues, val, _this.selectType);

          _this.getPolutionData(_this.selectId);
        });
      }); // this.getFlow(val)
    }
  },
  mounted: function mounted() {},
  methods: {
    // 控制轮播数据
    scroll: function scroll() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.waterWarnList.length > 6) {
          _this2.waterWarnList.push(_this2.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this2.waterWarnList.shift(); //删除数组的第一个元素

        }
      }, 500);
      setTimeout(function () {
        if (_this2.dateList.length > 14) {
          _this2.dateList.push(_this2.dateList[0]); // 将数组的第一个元素添加到数组的


          _this2.dateList.shift(); //删除数组的第一个元素

        }
      }, 500);
    },
    // 站点警报的tab切换
    changetadios: function changetadios(e) {
      this.defaultValues = e;
      if (e == 0) this.radioIndex = '';else this.radioIndex = e;
      this.getWarn(this.radioIndex, this.selectId, this.selectType); // this.getWarn(this.radioIndex,this.selectType)
    },
    //获取预警内容
    getWarn: function getWarn(category, siteId, st) {
      var _this3 = this;

      console.log(category, siteId, st);
      var params = {
        category: category,
        scope: 1,
        scopeId: siteId,
        warnStatus: 1 // current: 1,
        // size: 20

      }; // 污水站点

      queryScreenWarn(params).then(function (res) {
        if (res.success && res.result.length > 0) {
          res.result.forEach(function (item, index) {
            switch (item.category) {
              case '1':
                item.category_dictText = '数据报警';
                break;

              case '2':
                item.category_dictText = '设备报警';
                break;

              case '4':
                item.category_dictText = '离线预警';
                break;
            }
          });
          _this3.waterWarnList = res.result;
        } else {
          _this3.waterWarnList = [];
        }
      });
    },
    getDay: function getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + '-' + tMonth + '-' + tDate; // return tYear + '-' + tMonth + '-' + tDate+' '+hour+':'+minute+':'+second
    },
    doHandleMonth: function doHandleMonth(month) {
      var m = month;

      if (month.toString().length == 1) {
        m = '0' + month;
      }

      return m;
    },
    // 获取站点实时数据
    getRealtime: function getRealtime(id) {
      var _this4 = this;

      var param = {
        st: this.selectType,
        order: 'desc',
        scopeId: id,
        scope: 1,
        searchCount: true
      };
      var url = "/online/st".concat(this.selectType, "/realtime/");
      this.dateList = [];
      getAction(url, param).then(function (res) {
        if (res.success && res.result.records.length > 0) {
          var state;
          res.result.query.factors.forEach(function (item, index) {
            item.value = res.result.records[0].factor[item.code].hasOwnProperty('value') ? res.result.records[0].factor[item.code].value : '';

            if (res.result.records[0].factor[item.code].standard) {
              item.standTitle = res.result.records[0].factor[item.code].standard.title;
              item.standColor = res.result.records[0].factor[item.code].standard.color;
            } else {
              item.standTitle = '';
              item.standColor = '';
            }

            switch (res.result.records[0].factor[item.code].status) {
              case 0:
                state = '无数据';
                break;

              case 1:
                state = '正常';
                break;

              case 2:
                state = '低报';
                break;

              case 3:
                state = '高报';
                break;

              case 4:
                state = '数据异常';
                break;
            }

            item.state = state;
            item.render = _this4.renderCol(item.code, '', res.result.records[0]);
            state = '';
            return item;
          });
          _this4.standState = '';
          _this4.standLabel = '不达标';

          if (res.result.records[0].hasOwnProperty('attrs')) {
            if (res.result.records[0].attrs.hasOwnProperty('upStandard')) {
              _this4.standState = res.result.records[0].attrs.upStandard;
              _this4.standLabel = res.result.records[0].attrs.upStandard ? '达标' : '不达标';
            }

            _this4.standText = res.result.records[0].attrs.hasOwnProperty('currentStandard') ? res.result.records[0].attrs.currentStandard.hasOwnProperty('title') ? res.result.records[0].attrs.currentStandard.title : '' : '';
          }

          _this4.dateList = res.result.query.factors;
        } else {
          res.result.query.factors.forEach(function (item, index) {
            item.value = '';
            item.standColor = '';
            item.standTitle = '';
            item.state = '';
            item.render = '';
            return item;
          });
          _this4.standState = false;
          _this4.standText = '';
          _this4.standLabel = '不达标';
          _this4.dateList = res.result.query.factors;
        }
      });
    },
    renderCol: function renderCol(code, text, record) {
      var data = record.factor[code] || {
        value: ''
      };
      return '<span title=\'原始数据：' + (data.raw != null ? data.raw : '一') + '\'>' + (data.value != null ? data.value : '一') + '</span>';
    },
    getPolutionData: function getPolutionData(id, start) {
      var _this5 = this;

      if (id) this.siteId = id;
      if (!start) start = this.getDay(0);
      this.radioOptions = [];
      var selectedFactor = ['sl021', 'sl011'];
      queryWaterCurveAnalysis({
        scopeId: this.siteId,
        type: 1,
        stime: start,
        etime: this.getDay(0),
        dataType: this.analysisType
      }, this.selectType).then(function (res) {
        if (res.success) {
          if (res.result.records.length > 0) {
            var time = [];
            var labelData = [];
            var selectedObj = {};
            res.result.records.forEach(function (data) {
              time.push(data.dataTime);
            });
            var popArr = [];
            res.result.query.factors.forEach(function (ele) {
              if (selectedFactor.findIndex(function (item) {
                return item === ele.code;
              }) > -1) {
                selectedObj["".concat(ele.title, "(").concat(ele.unitName, ")")] = true;
              } else {
                selectedObj["".concat(ele.title, "(").concat(ele.unitName, ")")] = false;
              }

              labelData.push("".concat(ele.title, "(").concat(ele.unitName, ")"));
              var arr = [];
              res.result.records.forEach(function (item) {
                var obj = {
                  name: item.dataTime,
                  value: item.factor && item.factor.hasOwnProperty(ele.code) && item.factor[ele.code].hasOwnProperty('value') ? item.factor[ele.code].value : ''
                };
                arr.push(obj);
              });
              popArr.push({
                data: arr,
                title: "".concat(ele.title, "(").concat(ele.unitName, ")")
              }); // ele.time = time
              // ele.labelData = [`${ele.title}(${ele.unitName})`]
              // this.radioOptions.push(ele)
            });
            _this5.showAnalysis = false;

            _this5.$nextTick(function () {
              _this5.showAnalysis = true;

              _this5.$nextTick(function () {
                _this5.$refs.pollution.initBarChart(popArr, time, labelData, selectedObj, 7);
              });
            });
          } else {
            var _labelData = [];
            var _selectedObj = {};
            res.result.query.factors.forEach(function (item, index) {
              if (selectedFactor.findIndex(function (item) {
                return item === ele.code;
              }) > -1) {
                _selectedObj["".concat(ele.title, "(").concat(ele.unitName, ")")] = true;
              } else {
                _selectedObj["".concat(ele.title, "(").concat(ele.unitName, ")")] = false;
              }

              _labelData.push("".concat(ele.title, "(").concat(ele.unitName, ")"));
            });
            _this5.showAnalysis = false;

            _this5.$nextTick(function () {
              _this5.showAnalysis = true;

              _this5.$nextTick(function () {
                _this5.$refs.pollution.initBarChart([], [], _labelData, _selectedObj, 7);
              });
            });
          }
        }
      });
    },
    changeRadio: function changeRadio(e) {
      var time;

      switch (e.target.value) {
        // analysisType用于控制查询的水质趋势的类型  11:小时数据  12:日数据
        case 1:
          this.analysisType = 11;
          this.getPolutionData('', this.getDay(0));
          break;

        case 2:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(7));
          break;

        case 3:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(30));
          break;
      }
    },
    formatTrendValue: function formatTrendValue(value, now) {
      if (now != 0) {
        return (value - now) * 100 / now < 0 ? '下降' + Math.abs((value - now) * 100 / now).toFixed(2) + '%' : '上升' + Math.abs((value - now) * 100 / now).toFixed(2) + '%';
      } else {
        return '';
      }
    },
    // 获取流量分析数据
    // getFlow(id) {
    // 	queryWastehydrologyPie({
    // 		scopeId: id,
    // 		factorCodes: 'b03002,b03003'
    // 	}).then(res => {
    // 		if (res.success) {
    // 			this.flowState1 = false
    // 			this.$nextTick(() => {
    // 				this.flowState1 = true
    // 				this.$nextTick(() => {
    // 					let keys = Object.keys(res.result).reverse()
    // 					let data1 = res.result[keys[0]] ? (res.result[keys[0]].factor['b03002'] ? res.result[keys[0]].factor[
    // 						'b03002'].value : 0) : 0
    // 					let data2 = res.result[keys[2]] ? (res.result[keys[2]].factor['b03002'] ? res.result[keys[2]].factor[
    // 						'b03002'].value : 0) : 0
    // 					let data3 = res.result[keys[1]] ? (res.result[keys[1]].factor['b03002'] ? res.result[keys[1]].factor[
    // 						'b03002'].value : 0) : 0
    // 					let data4 = res.result[keys[0]] ? (res.result[keys[0]].factor['b03003'] ? res.result[keys[0]].factor[
    // 						'b03003'].value : 0) : 0
    // 					let data5 = res.result[keys[2]] ? (res.result[keys[2]].factor['b03003'] ? res.result[keys[2]].factor[
    // 						'b03003'].value : 0) : 0
    // 					let data6 = res.result[keys[1]] ? (res.result[keys[1]].factor['b03003'] ? res.result[keys[1]].factor[
    // 						'b03003'].value : 0) : 0
    // 					let dataStr = this.formatTrendValue(data1, data2)
    // 					let dataStr2 = this.formatTrendValue(data3, data2)
    // 					let dataStr3 = this.formatTrendValue(data4, data5)
    // 					let dataStr4 = this.formatTrendValue(data6, data5)
    // 					this.$refs.bartype4.initBarChart([data1, data2, data3], ['同比(' + dataStr + ')', '入库量', '环比(' + dataStr2 +
    // 						')'
    // 					], 1)
    // 					this.$refs.bartype5.initBarChart([data4, data5, data6], ['同比(' + dataStr3 + ')', '溢流量', '环比(' + dataStr4 +
    // 						')'
    // 					], 1)
    // 				})
    // 			})
    // 		}
    // 	})
    // 	// queryHydrologyFlowlist({
    // 	// 	id
    // 	// }).then(res => {
    // 	// 	if (res.success && res.result) {
    // 	// 		this.flowState = false
    // 	// 		this.$nextTick(()=>{
    // 	// 			this.flowState = true
    // 	// 			this.$nextTick(()=>{
    // 	// 				let data = res.result.pieFactors
    // 	// 				let dataStr = this.formatValue('b03004', 'YOY', data)
    // 	// 				let dataStr2 = this.formatValue('b03004', 'QOQ', data)
    // 	// 				let dataStr3 = this.formatValue('b03002', 'YOY', data)
    // 	// 				let dataStr4 = this.formatValue('b03002', 'QOQ', data)
    // 	// 				this.$refs.bartype4.initBarChart([data['b03004']['YOY'], data['b03004']['now'], data['b03004']['QOQ']], ['同比(' +
    // 	// 					dataStr + ')', '入库量', '环比(' + dataStr2 + ')'
    // 	// 				], 5000)
    // 	// 				this.$refs.bartype5.initBarChart([data['b03002']['YOY'], data['b03002']['now'], data['b03002']['QOQ']], ['同比(' +
    // 	// 					dataStr3 + ')', '溢流量', '环比(' + dataStr4 + ')'
    // 	// 				], 5000)
    // 	// 				let analysisData = []
    // 	// 				let analysisObj = {}
    // 	// 				let arr = []
    // 	// 				let dateArr = []
    // 	// 				if (res.result && res.result.data.length > 0) {
    // 	// 					res.result.data.forEach((item, index) => {
    // 	// 						dateArr.push(item.dateStr)
    // 	// 					})
    // 	// 					res.result.factors.forEach((item, index) => {
    // 	// 						let resArr = []
    // 	// 						res.result.data.forEach((item1, index1) => {
    // 	// 							resArr.push(item1.dataCodeMap[item.code].value.toFixed(2))
    // 	// 						})
    // 	// 						item.data = resArr
    // 	// 						return item
    // 	// 					})
    // 	// 					arr = res.result.factors
    // 	// 				}
    // 	// 				this.$refs.trendFlow.initBarChart(arr, dateArr)
    // 	// 			})
    // 	// 		})
    // 	// 	}
    // 	// })
    // },
    // formatData(res, title, code, type) {
    // 	let data = []
    // 	let obj = {}
    // 	for (let i = 0; i < 3; i++) {
    // 		obj.prevalue = res.result.pieFactors[code]['now'],
    // 			obj.hismax = 5000
    // 		obj.unit = 'm'
    // 		switch (i) {
    // 			case 0:
    // 				obj.name = '同比'
    // 				obj.value = res.result.pieFactors[code]['YOY'].toFixed(2)
    // 				break
    // 			case 1:
    // 				obj.name = title
    // 				obj.value = res.result.pieFactors[code]['now'].toFixed(2)
    // 				break
    // 			case 2:
    // 				obj.name = '环比'
    // 				obj.value = res.result.pieFactors[code]['QOQ'].toFixed(2)
    // 				break
    // 		}
    // 		data.push(obj)
    // 		obj = {}
    // 	}
    // 	let analysisData = []
    // 	let analysisObj = {}
    // 	let arr = []
    // 	let dateArr = []
    // 	if (res.result && res.result.data.length > 0) {
    // 		res.result.data.forEach((item, index) => {
    // 			analysisData.push(item.dataCodeMap[code].value.toFixed(2))
    // 			dateArr.push(item.dateStr)
    // 		})
    // 		analysisObj.title = '降雨量'
    // 		analysisObj.data = analysisData
    // 		arr.push(analysisObj)
    // 	}
    // 	switch (type) {
    // 		case 1:
    // 			this.$refs.trendRain.initBarChart(arr, dateArr)
    // 			this.$refs.ringRain.initBarChart(data)
    // 			break;
    // 		case 2:
    // 			this.$refs.trendStorage.initBarChart(arr, dateArr)
    // 			this.$refs.ringStorage.initBarChart(data)
    // 			break;
    // 		case 3:
    // 			this.$refs.trendWater.initBarChart(arr, dateArr)
    // 			this.$refs.ringWater.initBarChart(data)
    // 			break;
    // 	}
    // },
    formatValues: function formatValues(data, code, res, refs) {
      var arr = [];
      var dataArr = [];
      var dateArr = [];
      var obj = {};
      obj.title = data.title;
      res.result.records.forEach(function (item, index) {
        arr.push(item.factor[code].value != null ? item.factor[code].value : '');
        dateArr.push(item.dataTime);
      });
      obj.data = arr;
      dataArr.push(obj);
      this.$refs[refs].initBarChart(dataArr, dateArr, data.unitName);
    },
    formatRain: function formatRain(title, code, res, ref, unit) {
      // let title = '本月降雨量'
      var data = [];
      var obj = {};
      var keys = Object.keys(res.result).reverse();

      for (var i = 0; i < 3; i++) {
        obj.prevalue = res.result[keys[2]] ? res.result[keys[2]].factor[code].value.toFixed(2) : 0;
        obj.hismax = 5000;
        obj.unit = unit;

        switch (i) {
          case 0:
            obj.name = '同比';
            obj.value = res.result[keys[0]] ? res.result[keys[0]].factor[code].value.toFixed(2) : 0;
            break;

          case 1:
            obj.name = title;
            obj.value = res.result[keys[2]] ? res.result[keys[2]].factor[code].value.toFixed(2) : 0;
            break;

          case 2:
            obj.name = '环比';
            obj.value = res.result[keys[1]] ? res.result[keys[1]].factor[code].value.toFixed(2) : 0;
            break;
        }

        data.push(obj);
        obj = {};
      } // debugger


      this.$refs[ref].initBarChart(data);
    },
    // 获取各个曲线数据
    getAnalysis: function getAnalysis(id) {
      var _this6 = this;

      id = 2;
      var dataCode = ['b01002', 'b05001', 'b02002', 'b03002']; // queryWastehydrologyPie({
      //   scopeId: id,
      //   factorCodes: 'b01002,b05001,b02002,b03001,b03003',
      // }).then((res) => {

      var res = {
        'success': true,
        'message': '操作成功！',
        'code': 0,
        'result': {
          '2023-07-17': {
            'dataTime': '2023-07-17',
            'factor': {
              'b05001': {
                'raw': 893.34,
                'value': 893.34
              },
              'b02002': {
                'raw': 1057.06,
                'value': 1057.06
              },
              'b01002': {
                'raw': 0.0,
                'value': 0.0
              },
              'b03003': {
                'raw': 0.3,
                'value': 0.3
              },
              'b03001': {
                'raw': 0.7139184286,
                'value': 0.714
              }
            },
            'attrs': {
              'siteId': 2,
              'siteName': '鱼简河水库'
            }
          },
          '2023-06-17': {
            'dataTime': '2023-06-17',
            'factor': {
              'b05001': {
                'raw': 892.6791666667,
                'value': 892.679
              },
              'b02002': {
                'raw': 1057.0425,
                'value': 1057.043
              },
              'b01002': {
                'raw': 1.2,
                'value': 1.2
              },
              'b03003': {
                'raw': 0.3,
                'value': 0.3
              },
              'b03001': {
                'raw': 0.4408351667,
                'value': 0.441
              }
            },
            'attrs': {
              'siteId': 2,
              'siteName': '鱼简河水库'
            }
          },
          '2022-07-17': {
            'dataTime': '2022-07-17',
            'factor': {
              'b05001': {
                'raw': 842.3555208333,
                'value': 842.356
              },
              'b02002': {
                'raw': 1055.70125,
                'value': 1055.701
              },
              'b01002': {
                'raw': 12.4,
                'value': 12.4
              },
              'b03003': {
                'raw': 3.504861125,
                'value': 3.505
              },
              'b03001': {
                'raw': 0.0,
                'value': 0.0
              }
            },
            'attrs': {
              'siteId': 2,
              'siteName': '鱼简河水库'
            }
          }
        },
        'error': {},
        'timestamp': 1689575983626
      };

      if (res.success) {
        dataCode.forEach(function (item) {
          switch (item) {
            case 'b01002':
              _this6.showState1 = false;

              _this6.$nextTick(function () {
                _this6.showState1 = true;

                _this6.$nextTick(function () {
                  _this6.formatRain('本月累计降雨量', 'b01002', res, 'ringRain', _this6.data1.unitName); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                });
              });

              break;

            case 'b05001':
              _this6.storageState1 = false;

              _this6.$nextTick(function () {
                _this6.storageState1 = true;

                _this6.$nextTick(function () {
                  _this6.formatRain('本月平均库容', 'b05001', res, 'ringStorage', _this6.data4.unitName); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                });
              });

              break;

            case 'b02002':
              _this6.waterState1 = false;

              _this6.$nextTick(function () {
                _this6.waterState1 = true;

                _this6.$nextTick(function () {
                  _this6.formatRain('本月平均水位', 'b02002', res, 'ringWater', 'm'); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                });
              });

              break;

            case 'b03002':
              _this6.flowState1 = false;

              _this6.$nextTick(function () {
                _this6.flowState1 = true;

                _this6.$nextTick(function () {
                  var keys = Object.keys(res.result).reverse();
                  var data1 = res.result[keys[0]] ? res.result[keys[0]].factor['b03003'] ? res.result[keys[0]].factor['b03003'].value : 0 : 0;
                  var data2 = res.result[keys[2]] ? res.result[keys[2]].factor['b03003'] ? res.result[keys[2]].factor['b03003'].value : 0 : 0;
                  var data3 = res.result[keys[1]] ? res.result[keys[1]].factor['b03003'] ? res.result[keys[1]].factor['b03003'].value : 0 : 0;
                  var data4 = res.result[keys[0]] ? res.result[keys[0]].factor['b03001'] ? res.result[keys[0]].factor['b03001'].value : 0 : 0;
                  var data5 = res.result[keys[2]] ? res.result[keys[2]].factor['b03001'] ? res.result[keys[2]].factor['b03001'].value : 0 : 0;
                  var data6 = res.result[keys[1]] ? res.result[keys[1]].factor['b03001'] ? res.result[keys[1]].factor['b03001'].value : 0 : 0;

                  var dataStr = _this6.formatTrendValue(data1, data2);

                  var dataStr2 = _this6.formatTrendValue(data3, data2);

                  var dataStr3 = _this6.formatTrendValue(data4, data5);

                  var dataStr4 = _this6.formatTrendValue(data6, data5);

                  _this6.$refs.bartype4.initBarChart([data1, data2, data3], ['同比(' + dataStr + ')', '入库量(' + _this6.data6.unitName + ')', '环比(' + dataStr2 + ')'], 1);

                  _this6.$refs.bartype5.initBarChart([data4, data5, data6], ['同比(' + dataStr3 + ')', '溢流量(' + _this6.data5.unitName + ')', '环比(' + dataStr4 + ')'], 1);
                });
              });

              break;
          }
        });
      } // })
      // queryWastehydrologyPie({
      // 	scopeId: id,
      // 	factorCodes: 'b05001'
      // }).then(res => {
      // 	if (res.success) {
      // 	}
      // })
      // queryWastehydrologyPie({
      // 	scopeId: id,
      // 	factorCodes: 'b02002'
      // }).then(res => {
      // 	if (res.success) {
      // 		this.waterState1 = false
      // 		this.$nextTick(() => {
      // 			this.waterState1 = true
      // 			this.$nextTick(() => {
      // 				this.formatRain('本月平均水位', 'b02002', res, 'ringWater', this.data3.unitName)
      // 				// this.formatData(res, '本月累计降雨量', 'b01002', 1)
      // 			})
      // 		})
      // 	}
      // })
      // 降雨分析数据


      queryWastehydrologyCurveAnalysis({
        stime: this.getDay(30),
        etime: this.getDay(0),
        scopeId: id,
        type: 1,
        dataType: 12 // factorCodes: 'b01002',

      }).then(function (res) {
        if (res.success && res.result.records.length > 0) {
          dataCode.forEach(function (item) {
            switch (item) {
              case 'b01002':
                _this6.showState = false;

                _this6.$nextTick(function () {
                  _this6.showState = true;

                  _this6.$nextTick(function () {
                    _this6.formatValues(_this6.data1, 'b01002', res, 'trendRain'); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                  });
                });

                break;

              case 'b05001':
                _this6.storageState = false;

                _this6.$nextTick(function () {
                  _this6.storageState = true;

                  _this6.$nextTick(function () {
                    _this6.formatValues({
                      title: '渗流'
                    }, 'b05001', res, 'trendStorage'); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                  });
                });

                break;

              case 'b02002':
                _this6.waterState = false;

                _this6.$nextTick(function () {
                  _this6.waterState = true;

                  _this6.$nextTick(function () {
                    _this6.formatValues(_this6.data3, 'b02002', res, 'trendWater'); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                  });
                });

                break;

              case 'b03002':
                _this6.flowState = false;

                _this6.$nextTick(function () {
                  _this6.flowState = true;

                  _this6.$nextTick(function () {
                    var dateArr = [];
                    var Arr1 = [];
                    var Arr2 = [];
                    var dataArr = [];
                    res.result.records.forEach(function (item, index) {
                      dateArr.push(item.dataTime);
                      Arr1.push(100 + index % 9 * 0.1); // Arr2.push(item.factor['b03004'].value ? item.factor['b03004'].value : 0)
                    });
                    var obj1 = {}; // let obj2 = {}

                    obj1.title = '渗压';
                    obj1.data = Arr1; // obj2.title = this.data7.title
                    // obj2.data = Arr2

                    dataArr.push(obj1); // dataArr.push(obj2)

                    _this6.$refs.trendFlow.initBarChart(dataArr, dateArr); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                  });
                });

            }
          });
        }
      }); // 库容分析
      // queryWastehydrologyCurveAnalysis({
      // 	stime: this.getDay(30),
      // 	etime: this.getDay(0),
      // 	scopeId: id,
      // 	type: 1,
      // 	dataType: 12,
      // 	factorCodes: 'b05001',
      // }).then(res => {
      // 	if (res.success && res.result.records.length > 0) {
      // 	}
      // })
      // // 水位分析
      // queryWastehydrologyCurveAnalysis({
      // 	stime: this.getDay(30),
      // 	etime: this.getDay(0),
      // 	scopeId: id,
      // 	type: 1,
      // 	dataType: 12,
      // 	factorCodes: 'b02002',
      // }).then(res => {
      // 	if (res.success && res.result.records.length > 0) {
      // 		this.waterState = false
      // 		this.$nextTick(() => {
      // 			this.waterState = true
      // 			this.$nextTick(() => {
      // 				this.formatValues('降雨量', 'b02002', res, 'trendWater')
      // 				// this.formatData(res, '本月累计降雨量', 'b01002', 1)
      // 			})
      // 		})
      // 	}
      // })
      // queryWastehydrologyCurveAnalysis({
      // 	stime: this.getDay(30),
      // 	etime: this.getDay(0),
      // 	scopeId: id,
      // 	type: 1,
      // 	dataType: 12,
      // 	factorCodes: 'b01002',
      // }).then(res=>{
      // 	if (res.success && res.result.records.length>0) {
      // 		this.showState = false
      // 		this.$nextTick(() => {
      // 			this.showState = true
      // 			this.$nextTick(() => {
      // 				this.formatValues('降雨量','b01002',res)
      // 				// this.formatData(res, '本月累计降雨量', 'b01002', 1)
      // 			})
      // 		})
      // 	}
      // })
      // 注释部分
      // queryHydrologyAnalysislist({
      // 	id
      // }).then(res => {
      // 	if (res.success) {
      // 		this.showState = false
      // 		this.$nextTick(() => {
      // 			this.showState = true
      // 			this.$nextTick(() => {
      // 				this.formatData(res, '本月累计降雨量', 'b01002', 1)
      // 			})
      // 		})
      // 	}
      // })
      // 库容分析数据
      // queryHydrologyCapacitylist({
      // 	id
      // }).then(res => {
      // 	if (res.success) {
      // 		this.storageState = false
      // 		this.$nextTick(() => {
      // 			this.storageState = true
      // 			this.$nextTick(() => {
      // 				this.formatData(res, '本月平均库容', 'b05001', 2)
      // 			})
      // 		})
      // 	}
      // })
      // // 水位分析数据
      // queryHydrologyStagelist({
      // 	id
      // }).then(res => {
      // 	if (res.success) {
      // 		this.waterState = false
      // 		this.$nextTick(() => {
      // 			this.waterState = true
      // 			this.$nextTick(() => {
      // 				this.formatData(res, '本月平均水位', 'b02002', 3)
      // 			})
      // 		})
      // 	}
      // })
    }
  }
};